import { useState, useEffect } from 'react'

const useCountDown = initialSeconds => {
  const [counter, setCounter] = useState(initialSeconds)
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    let intervalId
    if (isActive && counter > 0) {
      intervalId = setInterval(() => {
        setCounter(prevSeconds => prevSeconds - 1)
      }, 1000)
    }
    return () => clearInterval(intervalId)
  }, [isActive, counter])

  const start = () => {
    setIsActive(true)
  }

  const reset = () => {
    setIsActive(false)
    setCounter(initialSeconds)
  }

  return { counter, isActive, start, reset }
}

export default useCountDown
